import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["file", "progress", "submitButton"]

  connect() {
    this.fileTarget.addEventListener("change", this.handleFileSelect.bind(this))
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.uploadFile(file)
    }
  }

  uploadFile(file) {
    this.progressTarget.classList.remove("hidden")
    this.submitButtonTarget.disabled = true

    const upload = new DirectUpload(file, "/rails/active_storage/direct_uploads", this)
    upload.create((error, blob) => {
      if (error) {
        console.error("Upload error:", error)
        this.progressTarget.classList.add("hidden")
        this.submitButtonTarget.disabled = false
      } else {
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden")
        hiddenField.setAttribute("value", blob.signed_id)
        hiddenField.name = "file"
        this.element.appendChild(hiddenField)
        this.submitButtonTarget.disabled = false
      }
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    const progress = Math.round((event.loaded / event.total) * 100)
    const loadedMB = (event.loaded / (1024 * 1024)).toFixed(2)
    const totalMB = (event.total / (1024 * 1024)).toFixed(2)

    this.progressTarget.innerHTML = `
      <div class="text-sm text-gray-600">
        Uploading: ${progress}% (${loadedMB} MB / ${totalMB} MB)
      </div>
    `
  }
} 